import { useCheckIsMobile } from "@sellernote/shared/src/utils/hook";

import { UtilitySectionData } from "../../types";

import UtilityCardHeader from "./Header";
import UtilityCardImage from "./Image";
import Styled from "./index.styles";

export default function UtilityCard({
  data: { title, description, imageUrl, mobileImageUrl },
  sequence,
  isActiveTarget,
}: {
  data: UtilitySectionData;
  sequence: number;
  isActiveTarget: boolean;
}) {
  const { isMobile } = useCheckIsMobile();

  return (
    <Styled.utilityCard
      sequence={sequence}
      className={
        isMobile
          ? undefined
          : `fade-in-and-spring-animation ${isActiveTarget ? "active" : ""}`
      }
    >
      <article className="utility-card">
        <UtilityCardHeader
          title={title}
          description={description}
          sequence={sequence}
        />

        <UtilityCardImage imageUrl={imageUrl} mobileImageUrl={mobileImageUrl} />
      </article>
    </Styled.utilityCard>
  );
}
